<template>
    <v-container fluid class="ma-0 pa-0">
        <v-row no-gutters style="flex-wrap: nowrap;">
            <v-col cols="2"
                   class="flex-grow-0 flex-shrink-0">
                <v-card outlined
                        tile>
                    <!--<v-navigation-drawer clipped permanent>-->
                        <FilterList></FilterList>
                    <!--</v-navigation-drawer>-->
                </v-card>
            </v-col>
            <v-col cols="1"
                   style="min-width: 100px; max-width: 100%;"
                   class="flex-grow-1 flex-shrink-0">
                <VuePerfectScrollbar class="drawer-menu--scroll leftRightMainContainer">
                    <v-card outlined
                            tile>
                        <SegmentCompositeChart v-on:next="next" style="height:100%"></SegmentCompositeChart>
                    </v-card>
                    <v-card outlined
                            tile>
                        <DataTable :headerData="headerData" :tableData="tableData" :showQuestionNumber="true"></DataTable>
                    </v-card>
                </VuePerfectScrollbar>
            </v-col>
        </v-row>
    </v-container>

    <!--<v-container fluid grid-list-md pa-1>
        <v-layout row wrap>
            <v-flex xs2 sm2 md2>
                <div class="v-card">
                    <v-navigation-drawer class="leftRightMainContainer navigationDrawer" permanent>
                        <FilterList></FilterList>
                    </v-navigation-drawer>
                </div>
            </v-flex>
            <v-flex xs10 sm10 md10>
                <div class="v-card">
                    <VuePerfectScrollbar class="drawer-menu--scroll leftRightMainContainer">
                        <v-layout row wrap style="width:100%" fill-height class="segmentCohortMainLayout">
                            <v-flex class="pa-0 pb-1">
                                <SegmentCompositeChart v-on:next="next"></SegmentCompositeChart>
                            </v-flex>
                            <v-flex class="pa-0">
                                <DataTable :headerData="headerData"
                                           :tableData="tableData" :showQuestionNumber="true">
                                </DataTable>
                            </v-flex>
                        </v-layout>
                    </VuePerfectScrollbar>
                </div>
            </v-flex>
        </v-layout>
    </v-container>-->
</template>
<script>
    import { mapState } from 'vuex';
    import FilterList from "../FilterList";
    //import StarRatingMeasureChart from './Charts/StarRatingMeasureChart'
    import SegmentCompositeChart from '../Charts/SegmentCompositeChart'
    import DataTable from '../DataTable'
    import VuePerfectScrollbar from 'vue-perfect-scrollbar'
    import '../../../../assets/BenchmarkBuilderStyles.css'


    export default {
        components: {
            FilterList,
            //StarRatingMeasureChart,
            SegmentCompositeChart,
            DataTable,
            VuePerfectScrollbar
        },
        data() {
            return {
                active: null,
            }
        },
        methods: {
            next() {
                //this.$emit('next');
                this.$router.push('/Medicare/Cohort');
            },
            checkIfSegmentSelected() {
                return true;
            }
        },
        computed: {
            binding() {
                const binding = {}
                if (this.$vuetify.breakpoint.mdAndUp) binding.column = true
                return binding
            },
            ...mapState({
                Tab: state => state.AppStore.tab,
                modelSegmentFilters: state => state.CategoriesStore.modelSegmentFilters,
                headerData: state => state.SegmentMeasureStore.headerData,
                tableData: state => state.SegmentMeasureStore.tableData,
            }),
        },
        created() {
            // console.log(this.PRODUCT_LINE_COMMERCIAL);
            this.$store.dispatch('AppStore/SetTab', this.TAB_SEGMENT_MEASURE);
        }
    };
</script>
<style scoped>
    .drawer-menu--scroll {
        overflow: auto;
    }

    .scroll-area {
        position: absolute;
        margin: auto;
    }
</style>
